import { client } from "../net/client";
import { fa } from "./cards";
import { unitName } from "./watching";
import { Overlay } from "../ui/Overlay";

/**
 * پایانِ مسابقه.
 *
 * بی این، میزِ تمام‌شده روی صفحه می‌مانْد و بازیکن راهی جز دکمه‌ی «بیرون» نداشت —
 * که مثلِ فرار از میز به نظر می‌رسد، نه پایانِ بازی.
 */
/**
 * `lowestWins`: در هفت خبیث امتیاز جریمه است، پس برنده کم‌ترین امتیاز را دارد —
 * برعکسِ حکم و چهاربرگ. بی این پرچم، بازنده «بردی!» می‌دید.
 */
export function MatchOver({ score, me, units, lowestWins = false, watching = false }:
  { score: number[]; me: number; units: number; lowestWins?: boolean; watching?: boolean }) {
  const mine = units > 0 ? me % units : 0;
  const best = score.indexOf(lowestWins ? Math.min(...score) : Math.max(...score));
  const won = best === mine;
  return (
    <Overlay label="پایانِ مسابقه">
      <div style={{ fontSize: 26, fontWeight: 700, color: watching || won ? "var(--gold-bright)" : "#ffb4ab" }}>
        {watching ? `${unitName(best, units < 4)} بُرد` : won ? "بردی!" : "باختی"}
      </div>
      <div className="muted">{score.map(fa).join("  -  ")}</div>
      <button className="btn" style={{ maxWidth: 260 }} onClick={() => client.exitTable()}>
        {watching ? "پایانِ تماشا" : "بازگشت به لابی"}
      </button>
    </Overlay>
  );
}
